import {
    AuthType,
    CognitoAuthOptions,
    MfaStatusEnum,
    PasswordChangeRequest,
    User
} from "../types";
import { CognitoUser } from "amazon-cognito-identity-js";
import { OktaAuthOptions } from "@okta/okta-auth-js";
import _ from "lodash";
import { useUserStore } from "@/shared/store/user";
import { OktaAuth as OktaAuthApi } from "@/shared/api/okta_auth";
import { CognitoAuth as Cognito } from "@/shared/api/cognito_auth";


class AuthenticationFactory {
    private cognito = null;
    private okta = null;

    init (cognitoOptions: CognitoAuthOptions, oktaOptions: OktaAuthOptions) {
        this.cognito = new Cognito(cognitoOptions);
        this.okta = new OktaAuthApi(oktaOptions);
    }

    getAuth () {
        const userStore = useUserStore();
        return userStore.authType === AuthType.Okta ? this.okta : this.cognito;
    }

    getAuthByType (authType: AuthType) {
        return authType === AuthType.Okta ? this.okta : this.cognito;
    }
}

export const AuthFactory: AuthenticationFactory = new AuthenticationFactory();
export const CognitoAuth = () => AuthFactory.getAuthByType(AuthType.Cognito);
export const OktaAuth = () => AuthFactory.getAuthByType(AuthType.Okta);

export interface Authentication {
    login: (username: string, password: string, requiredGroups: ReadonlyArray<string>,
            mfaFunc: (s: MfaStatusEnum, u: CognitoUser) => void) => Promise<User>;
    setInitialPassword: (username: string, oldPassword: string, newPassword: string,
                         mfaFunc: (s: MfaStatusEnum, u: CognitoUser) => void) => Promise<User>;
    logout: () => void;
    accessToken: () => Promise<string>;
    forceRefreshSession: () => Promise<User>;
    resetPassword: (username: string) => Promise<any>;
    autoRecoverUser: (email: string) => Promise<any>;
    confirmPassword: (username: string, verificationCode: string, password: string) => Promise<any>;
    getUser: () => { username };
    changePassword: (request: PasswordChangeRequest) => Promise<void>;
}
